/**
 * CargaDestinatarioCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaDestinatario} from '@/model/resource/CargaDestinatario'

/* TODO: review generated class */
@HttpExclude()
export class CargaDestinatarioCollection extends PageCollection<
  CargaDestinatario
> {
  constructor() {
    super(CargaDestinatario)
  }

  queryAsPage() {
    return this.listCargaDestinatario()
  }

  async listCargaDestinatario() {
    return await Request.get(`/admin/carga-destinatario`, {params: this.params})
      .name('listCargaDestinatario')
      .as(this)
      .getResponse()
  }

  async listCsvCargaDestinatario() {
    return await Request.get(`/admin/carga-destinatario/csv`, {
      params: this.params,
    })
      .name('listCsvCargaDestinatario')
      .as(this)
      .getResponse()
  }
}
